import React from "react";
import { Link } from "react-router-dom";

/**
 * <PrivacyNotice /> — a compact just-in-time notice shown next to any form that
 * collects personal data (email signup, register, checkout, feedback, etc.).
 * Satisfies Art. 13 GDPR "information at the time of collection".
 *
 * Props:
 *   purpose  — one sentence describing why the data is collected
 *   testid   — optional data-testid to distinguish per-form notices
 */
export default function PrivacyNotice({ purpose, testid = "privacy-notice" }) {
  return (
    <p
      data-testid={testid}
      className="text-[11px] leading-relaxed text-muted_ink mt-3"
    >
      {purpose ? `${purpose} ` : ""}
      By continuing you agree to our{" "}
      <Link
        to="/privacy"
        className="underline hover:text-terracotta"
        data-testid={`${testid}-link`}
      >
        privacy policy
      </Link>
      . You can withdraw consent or request deletion at any time.
    </p>
  );
}
